export default __webpack_public_path__ + "static/media/hospice-data-commons-logo.11549a7b.png";